import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import Account from './../Account/Template/index.vue'; //Account
import RightSidebar from './../../components/templates/rightsidebar.vue'; 
import LeftSidebar from './../../components/templates/leftsidebar.vue'; 

let service = new services();
export default {
    name: 'Home',
    props: {
        paymentdata:Object,
    },
    watch: { 
        paymentdata: function(newVal, oldVal) { // watch this prop
            //this.set_chat_view = false; //reload
            //this.chat_log = []; //reload
            this.setPaymentDetails();
           // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        }
    },
    
    data () {
        return {
            user:{},
            payment_mode:1, //default automatic payment
            payment_message:"",
            payment_active_resolve_ref:"",
            payment_service_update_data_status: 0,
            payment_service_update_data:"",
            loading:false,
            action_loading:false,
            disable_btn:false,
        }
    },
  
    components: {
        'component-account': Account,
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'right-sidebar': RightSidebar,
        'left-sidebar': LeftSidebar,
    },
    
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        }
    },

    methods: {
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        setComponent(attr1,attr2){
            if(attr1 == "reset-edit"){}
        },

        setMenuTabView(view,attr1,attr2){
            if(this.menu_tab_view[view] == true){//toggle reverse
                this.menu_tab_view = {};
                this.setComponent('reset-edit','');
            }else{
                this.setComponent('reset-edit','');
                this.menu_tab_view = {};
                this.menu_tab_view[view] = true;
            }
        },

        preset(){
        // this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.loading = false;
                }else {
                   // self.getCheckoutLocalOrder();
                }
            });
           
        },

        setPaymentDetails(){},

        processPaymentSingleXX(payment_mode){ 
            let data = this.paymentdata;
            this.activate_processing();
            let paydata = {};
            //base data
            paydata.payment_data = data;
            //payer details
            paydata.payer = {
                payerName:data.payer_name,
                payerEmail:data.payer_email,
                payerPhone:data.payer_phone,
            };
            //other details
            paydata.payment_total_amount = data.payment_total_amount;
            paydata.payment_currency = data.payment_currency;
            paydata.payment_ref = data.payment_ref;
            paydata.payment_details = data.payment_details;
            // paydata.processing_fee_status = data.pay_processing_fee_status;
            // paydata.payment_processing_fee_transaction_type = data.pay_processing_fee_transaction_type;
            // paydata.processing_fee = data.pay_processing_fee;
            paydata.payment_transaction_type = data.payment_transaction_type;
            paydata.payment_transaction_module_id = data.payment_transaction_module_id;
            paydata.payment_data_index = data.payment_data_index;
            paydata.payment_data_route = data.payment_data_route;
            
            //set sub accounts
            paydata.payment_subaccounts = data.payment_sub_accounts;
            

            //set payment meta
            paydata.payment_meta = data.payment_meta;
            // if((Object.keys(data.payment_meta).length !== 0)){
            //     data.paymeta.forEach(function(meta) {
            //         var meta_value = {
            //             metaname: meta.metaname,
            //             metavalue: meta.meta,
            //         }
            //         paydata.payment_meta.push(meta_value);
            //     });
            // }
            
            
            if(payment_mode == 1){
                paydata.payment_mode = 1;//gateway
                this.processPaymentRavepay(paydata);
            }

            if(payment_mode == 2){
                paydata.payment_mode = 2;//collections
                this.updatePaymentSingle(paydata); 
            }

            if(payment_mode == 3){
                paydata.payment_mode = 3;//manualTransfer
                this.updatePaymentSingle(paydata);
            }
           
       
        },

        // update payments
        updatePaymentSingleXX(paydata) {
            //some settings
           
            var payload = {
                payment_service_type:"single",
                payment_service_ref: paydata.payment_ref,
                payment_service_amount_paid: paydata.total_amount,
                payment_service_user_id: this.user.user_id,
                payment_service_payment_data: paydata.payment_data,
                payment_service_payment_details: paydata.payment_details,
                //processing fee details
                payment_service_processing_fee_status: paydata.processing_fee_status,
                payment_service_processing_fee_transaction_type: paydata.payment_processing_fee_transaction_type,
                payment_service_processing_fee_transaction_amount:paydata.payment_processing_fee,
                //manual payment updates and confirmation
                payment_service_mode:paydata.payment_mode,
                payment_service_transaction_type:paydata.payment_transaction_type,
                payment_service_transaction_module_id:paydata.payment_transaction_module_id,
            }
            let navi = this.$router;
            
            if(payment_ref != "") {
                service.updatePaymentService(this, payload).then(data => {
                    if(data.body.status == 200) {
                        //return order id if one and navigate with it to orders
                        // toastr.success("Payment Processed!", "Success!");
                        this.data_processing_message = "Payment Processed!";
                        this.checkout_orders[index] = data.body.data;
                        this.processed_single_order_count++;
                        // location.replace("/orders/");
                        this.deactivate_processing();
                    }else {
                        //console.log("error")
                        // toastr.error('Sorry, could not update payment', 'Warning!');
                        this.data_processing_message = "Sorry, could not update payment";
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    if(err) {
                        // console.log(err)
                        // toastr.error('Sorry, could not process information', 'Warning!');
                        this.data_processing_message = "Sorry, could not process information";
                        this.deactivate_processing();
                    }
                })
            }else {
                // toastr.error('Something went wrong', 'Warning!');
                this.data_processing_message = "Something went wrong";
                this.deactivate_processing();
            }
            
        },
 
        prepProcessPaymentSingle(payment_mode,payment_status){ //for set and get payment ref from server
            this.activate_processing();
            let has_set_payment_ref = 0;
            let set_payment_mode = payment_mode; //may be overridden

            //checks
            if(this.paymentdata.payment_transaction_type == 3){
                set_payment_mode = 4; //for manual order confirmation pending payments payment mode
            }
            var payload = {
                service_load: this.paymentdata.payment_service_payment_data.pay_set,
                service_user: this.user.user_id,
                service_payment_transaction_type: this.paymentdata.payment_transaction_type,
                service_total_amount: this.paymentdata.payment_total_amount,
                service_payment_mode: set_payment_mode,
                service_payment_by_payment_mode: payment_mode,
                service_is_part_payment: 0, //check value
                service_payment_status: payment_status,
                service_active_payment_ref: this.payment_active_resolve_ref
            }

            service.preparePayments(this, payload).then(data => {
                if((data.body.status == 200) || (data.body.status == 404)) { //404//afater no payments found if //conflicts
                    has_set_payment_ref = 1;
                    this.paymentdata.payment_service_ref = data.body.data.data_ref;
                }else {
                    let paymode = data.body.data_active_payment_mode;
                    let paydata = data.body;
                    if(data.body.status == 409) { //conflict flag with payment gateway
                        //check if payment has been previously made and is active
                        if(data.body.data_active_gateway_payment_check == 1){
                            this.verifyServerRavePayment(payment_mode,paydata);//do for ravepay
                        }else if((data.body.status == 409) && (data.body.data_paid_status == 200)) { //conflict with payment found
                            //check if payment has been previously made and is active
                           this.resolveActivePayment(payment_mode,paydata);
                        }
                    }else {
                        this.data_processing_message = "Sorry, could not update payment";
                    }
                }
                if(has_set_payment_ref == 1 && (this.paymentdata.payment_service_ref != '')){
                    this.processPaymentSingle(payment_mode);
                }

                //dissolve
                this.payment_active_resolve_ref = "";
            }).catch((err) => {
                if(err) {
                    this.data_processing_message = "Sorry, could not process information";
                }
                //dissolve
                this.payment_active_resolve_ref = "";
            })
        },

        verifyServerRavePayment(payment_mode,paydata){
            let payref = paydata.data_active_payment_service_ref;
            //server validation
            // let payload =
            // {
            //     "SECKEY": "FLWSECK-a235ea72184ac4d7c07ea2e356682cd7-X", //use API secret key
            //     "txref": payref
            // };
            let payload =
            {
                call_url: "https://api.flutterwave.com/v3/transactions/"+payref+"/verify",
                call_method: "GET",
                call_header: ["Content-Type: application/json",
                              "Authorization: FLWSECK-a235ea72184ac4d7c07ea2e356682cd7-X"]
            };
            service.verifyRavePayment(this, payload).then(response => {
                //console.log(response.body.status); 
                if ((response.body.status === "success")) {
                    //check if the amount is same as amount you wanted to charge just to be very sure
                    //also add check for currency
                    // if( (response.body.data.amount === order.total_amount) && (response.body.data.currency === "NGN")) { //get currency from server as passed
                    if( (response.body.data.amount === this.paymentdata.payment_total_amount)) { //get currency from server as passed
                        paydata.data_active_gateway_payment_check = "00";
                        paydata.data_active_gateway_payment_log_ref = payref;
                        this.resolveActivePayment(payment_mode,paydata);//do for ravepay
                    }
                    //self.payment_message = "Payment processed successfully, check your email for your receipts."
                }else{
                    //this.resolveActivePayment(order,index,payment_mode,paydata);
                    //set active payment ref to resolve
                    this.payment_active_resolve_ref = payref;
                    //remake payment by gateway
                    this.prepProcessPaymentSingle(payment_mode,2); //2////set this active payment for resolve
                }
                //...//....server validation
            }).catch((err) => {
                if(err) {
                    this.data_processing_message = "Sorry, could not process information";
                }
            })
        },

        resolveActivePayment(payment_mode,payment_data){
            //add active payment data to pre generated pyment details
            this.paymentdata.payment_service_payment_data.active_payment_data = payment_data;
            this.paymentdata.payment_service_payment_data.active_payment_alert = 1;
            this.paymentdata.payment_service_payment_data.active_payment_ref = payment_data.data_active_payment_service_ref;
            
            //then call processpayment
            this.processPaymentSingle(payment_mode);
        },

        processPaymentSingle(payment_mode){
            this.activate_processing();
            let data = this.paymentdata;
            let paydata = {};
            //base data
            paydata.payment_data = data;
            //payer details
            paydata.payer = {
                payerName:data.payer_name,
                payerEmail:data.payer_email,
                payerPhone:data.payer_phone,
            };
            //other details
            paydata.payment_total_amount = data.payment_total_amount;
            paydata.payment_currency = data.payment_currency;
            paydata.payment_ref = data.payment_service_ref;
            paydata.payment_details = data.payment_details;
            paydata.payment_transaction_type = data.payment_transaction_type;
            paydata.payment_transaction_module_id = data.payment_transaction_module_id;
            paydata.payment_data_index = data.payment_data_index;
            paydata.payment_data_route = data.payment_data_route;
            
            //set sub accounts
            paydata.payment_subaccounts = data.payment_sub_accounts;
            //set payment meta
            paydata.payment_meta = data.payment_meta;
           
            //
            let active_payment_alert = 0;
            this.paymentdata.payment_service_payment_by_payment_mode = 0;
            if((this.paymentdata.active_payment_alert) && (this.paymentdata.active_payment_alert == 1)){
                active_payment_alert = 1;
            }
            if(payment_mode == 1){ 
                this.paymentdata.payment_service_payment_mode = 1;//gateway
                if(active_payment_alert == 1){
                    this.updatePaymentSingle(this.paymentdata.active_payment_ref); 
                }else{
                   this.updatePaymentSingle(paydata.payment_ref);
                    //this.processPaymentRavepay(paydata);
                }
            }

            if(payment_mode == 2){
                this.paymentdata.payment_service_payment_mode =  2;//collections
                if(active_payment_alert == 1){
                    this.updatePaymentSingle(this.paymentdata.active_payment_ref); 
                }else{
                    this.updatePaymentSingle(this.paymentdata.payment_service_ref); 
                }     
            }

            if(payment_mode == 3){
                this.paymentdata.payment_service_payment_mode = 3;//manualTransfer
                if(active_payment_alert == 1){
                    this.updatePaymentSingle(this.paymentdata.active_payment_ref); 
                }else{
                    this.updatePaymentSingle(this.paymentdata.payment_service_ref);
                }
            }

            if(payment_mode == 5){
                this.paymentdata.payment_service_payment_mode =  5;//payment/processing fees account
                if(active_payment_alert == 1){
                    this.updatePaymentSingle(this.paymentdata.active_payment_ref); 
                }else{
                    this.updatePaymentSingle(this.paymentdata.payment_service_ref); 
                }     
            }
       
        },

        processPaymentRavepay(paydata) {
            let self = this;
            var x = getpaidSetup({
                PBFPubKey: service.ravepay_public_test, //test //devlot
                // PBFPubKey: service.ravepay_public_live_paga, //api public key
                customer_email: paydata.payer.payerEmail, // "mail@gmail.com"
                amount: paydata.payment_total_amount,//(Math.round(order.total_amount))//self.total_fee,
                customer_phone: paydata.payer.payerPhone, //"234099940409"
                currency: paydata.payment_currency,
                payment_method: "both",
                txref:paydata.payment_ref,
                subaccounts: paydata.payment_subaccounts,
                meta: paydata.payment_meta,
                onclose: function() {
                   //refresh
                },
                callback: function(response) {
                    var txref = response.tx.txRef; // collect flwRef returned and pass to a server page to complete status check.
                    var tx_amount = response.tx.amount;
                    if (
                        response.tx.chargeResponseCode == "00" ||
                        response.tx.chargeResponseCode == "0"
                    ) {
                        self.updatePaymentSingle(txref); 
                        //server validation
                        // let payload =
                        // {
                        //    "SECKEY": service.ravepay_secret_live_paga, //use API secret key
                        //     "txref": txref
                        // };
                        // service.verifyRavePayment(self, payload).then(response => {
                            
                        // }).catch((err) => {
                            
                        // })
                    } else {
                        self.payment_message = "Payment unsuccessfull. please try again or contact us"
                    }
                }
            });
        },
        //../process payments

        
        // update payments
        updatePaymentSingle(payment_service_ref) {
            //some settings
            let service_to_pay = this.paymentdata.payment_service_payment_data.payment_services[0]; //actual single service been paid for
            let processing_fee_transaction_type = 0;
            //
            if(this.paymentdata.payment_transaction_type == 3){ //manual order confirmation pending payments
                if(service_to_pay.order_processing_fee_status == 3){//seller pays
                    processing_fee_transaction_type = 2;//processing fee deduct from balance
                    //add to service data
                    service_to_pay.processing_fee_transaction_type = processing_fee_transaction_type;
                    service_to_pay.processing_fee_transaction_amount = service_to_pay.order_processing_fee;
                }
                this.paymentdata.payment_service_payment_data.payment_manual_payment_to_agent = 0; //ini
                if(service_to_pay.order_receive_manual_payment_by == 2){//agent is receiving
                    this.paymentdata.payment_service_payment_data.payment_manual_payment_to_agent = 1;
                }
            }else{
                if(service_to_pay.service_processing_fee_status == 3){//seller pays
                    processing_fee_transaction_type = 2;//processing fee deduct from balance
                    //add to service data
                    service_to_pay.processing_fee_transaction_type = processing_fee_transaction_type;
                    service_to_pay.processing_fee_transaction_amount = service_to_pay.service_processing_fee;
                }
            }
            
            //checks and //overrides
            if(this.paymentdata.payment_transaction_type == 3){//for manual order confirmation pending payments payment mode
                this.paymentdata.payment_service_payment_by_payment_mode = this.paymentdata.payment_service_payment_mode; //payment_service_payment_by_payment_mode //by gteway
                this.paymentdata.payment_service_payment_mode = 4; //override and set to 4 //for proper processing
            }
            
            // this.paymentdata.payment_details = order.order_details;
            //let payment_service_payment_data = this.paymentdata;
            //add more data to payment_service_payment_data
            // this.process_orders_update.push(order);
            // payment_service_payment_data.payment_services = this.process_orders_update;
            //check if agent accepted manual trnsfer
            // if(order.order_payment_mode == 3){
            //     if(order.order_receive_manual_payment_by == 2){//agent is receiving
            //         payment_service_payment_data.payment_manual_payment_to_agent = 1;
            //     }
            // }
            var payload = {
                // payment_sevice_type:"single",
                payment_service_ref: payment_service_ref,
                payment_service_amount_paid: this.paymentdata.payment_total_amount,
                //payment_user_id: this.user.user_id,
                // payment_orders: order,
                // payment_details: order.order_details,
                //processing fee details
                // processing_fee_transaction_type: processing_fee_transaction_type,
                // processing_fee_transaction_amount:order.order_processing_fee,
                //manual payment updates and confirmation
                // payment_update_type:update_type,

                //updated use for now //new version with payment service
                payment_service_payment_data: this.paymentdata.payment_service_payment_data,
                payment_service_mode: this.paymentdata.payment_service_payment_mode,
                payment_service_payment_by_payment_mode: this.paymentdata.payment_service_payment_by_payment_mode,
                payment_service_type:this.paymentdata.payment_sevice_type,
                //
                payment_service_user_id: this.user.user_id,
                payment_service_processing_fee_transaction_type: processing_fee_transaction_type,
                payment_service_processing_fee_transaction_amount: service_to_pay.processing_fee_transaction_amount,
                //
            }
            let navi = this.$router;
            
            if(payment_service_ref != "") {
                service.updatePayment(this, payload).then(data => {
                    if((data.body.status == 200) || (data.body.status == 400)) {
                        //return order id if one and navigate with it to orders
                        // toastr.success("Payment Processed!", "Success!");
                        this.data_processing_message = "Payment Processed!";
                        // this.checkout_orders[index] = data.body.data;
                        // this.processed_single_order_count++;
                        // location.replace("/orders/");
                        //this.payment_service_update_data = data.body.data;
                        if(this.paymentdata.payment_transaction_type == 3){ //manual order payment settlements
                            if(data.body.data_pending_pay_status == 200){
                                this.payment_service_update_data_status = 200; 
                                this.payment_service_update_data = data.body.data_pending_pay_data;
                            }
                        }
                        this.deactivate_processing();
                    }else {
                        //console.log("error")
                        // toastr.error('Sorry, could not update payment', 'Warning!');
                        this.data_processing_message = "Sorry, could not update payment";
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    if(err) {
                        // console.log(err)
                        // toastr.error('Sorry, could not process information', 'Warning!');
                        this.data_processing_message = "Sorry, could not process information";
                        this.deactivate_processing();
                    }
                })
            }else {
                // toastr.error('Something went wrong', 'Warning!');
                this.data_processing_message = "Something went wrong";
                this.deactivate_processing();
            }
            
        },

    },
    created: function(){
        // console.log(this.paymentdata)
        this.preset();
    }
}


// WEBPACK FOOTER //
// ./src/pages/PaymentService/script.js